module.exports = __webpack_public_path__ + "img/xingyun.215286d0.png";